import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loading from '@/components/Loading.vue';
import CardSet from '@/components/CardSet.vue';
import BackButton from '@/components/BackButton.vue';
const blobsModule = namespace('blobs');
let VariantRules = class VariantRules extends Vue {
    created() {
        this.fetchVariantRuleBlobs();
    }
    get variantRuleBlobsWithLinks() {
        return this.variantRuleBlobs.map(variantRuleBlob => ({
            ...variantRuleBlob,
            to: `variantRules/${variantRuleBlob.chapterName}`
        }));
    }
};
__decorate([
    blobsModule.State
], VariantRules.prototype, "variantRuleBlobs", void 0);
__decorate([
    blobsModule.Action
], VariantRules.prototype, "fetchVariantRuleBlobs", void 0);
VariantRules = __decorate([
    Component({
        components: {
            Loading,
            BackButton,
            CardSet
        }
    })
], VariantRules);
export default VariantRules;
